module.exports = __webpack_public_path__ + "static/img/pic5.84a9b508.png";